module.exports = __webpack_public_path__ + "static/media/arrow-left.e29f7bdc.svg";